import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AuditLogsService } from 'app/service/audit-logs-service';
import { AuditProgramLogBean } from './../../../model/audit-program-log-bean';
import { CommonDTO } from 'app/model/common-dto';
import { ManageAuditProgramDto } from 'app/model/manage-audit-program-dto';
import { MatTableDataSource } from '@angular/material/table';
import { PeriodicElement } from './../../interfaces/periodicElement';

@Component({
  selector: 'app-auditlogs',
  templateUrl: './auditlogs.component.html',
  styleUrls: ['./auditlogs.component.scss'],
})
export class AuditlogsComponent implements OnInit {
  displayedColumns: string[] = ['position', 'eventType', 'actionBy', 'actionDate'];
  dataSource = new MatTableDataSource();
  auditProgramLogBean: AuditProgramLogBean[];
  auditName: string;
  commonDto: CommonDTO = new CommonDTO();
  @Input('auditProgramId') auditId: string;

  ELEMENT_DATA: PeriodicElement[] = [];
  noList: boolean;
  @Output() closePanellogs: EventEmitter<boolean> = new EventEmitter();
  constructor(private auditLogsService: AuditLogsService) {}

  ngOnInit() {
    this.getAuditProgramLogList(this.auditId);
  }

  getAuditProgramLogList(auditId: string) {
    this.commonDto.auditProgramId = auditId;
    this.auditLogsService.getAuditProgramLogList(this.commonDto).subscribe((data: any) => {
      this.auditProgramLogBean = data;
      if (data == null || data == '') {
        this.auditName = '';
        this.noList = true;
      } else {
        this.noList = false;
        this.auditName = this.auditProgramLogBean[0].auditName;
        this.ELEMENT_DATA = this.auditProgramLogBean;
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      }
    });
  }

  closed() {
    this.closePanellogs.emit(false);
  }
}
